module.exports = __webpack_public_path__ + "static/media/eleanor.68c6871f.jpg";